import { axios, BaseApiUrl } from '../axios_config';

// 查询重新上架列表
export const GetInventoryStorageChangeAsync = params =>{
    return axios.get(`${BaseApiUrl}/BackOn/GetInventoryStorageChangeAsync`,{ params }).then(res => res.data);
}

// 查询重新上架明细
export const GetInventoryStorageChangeDetailAsync = params =>{
    return axios.get(`${BaseApiUrl}/BackOn/GetInventoryStorageChangeDetailAsync`,{ params }).then(res => res.data);
}

// 确定上架
export const addPutaway = params =>{
    return axios.post(`${BaseApiUrl}/BackOn/AddInventoryChangeDetailAsync`, { ...params }).then(res => res.data);
}

// 结束上架
export const endPutaway = params =>{
    return axios.post(`${BaseApiUrl}/BackOn/AddInventoryChangeDetailEndOfShelvesAsync`, { ...params }).then(res => res.data);
}

